import apiClient from '../utils/apiClient';

/**
 * #210203 — yêu cầu duyệt check-in khi GPS lỗi.
 *
 * Nhân viên đứng ngay tại quán nhưng GPS điện thoại trôi (ảnh sếp gửi: "cách 1307m") bị chặn cứng.
 * Quản lý/Admin duyệt ở đây; server vẫn kiểm quyền lại, giao diện không phải chốt chặn duy nhất.
 */
export const gpsCheckInApprovalAPI = {
  list: async (params = {}) =>
    apiClient.get({ url: '/attendance/gps-approval-requests', params }),

  approve: async (id) =>
    apiClient.put({ url: `/attendance/gps-approval-requests/${id}/approve` }),

  reject: async (id, rejectReason) =>
    apiClient.put({
      url: `/attendance/gps-approval-requests/${id}/reject`,
      data: { reject_reason: rejectReason },
    }),
};
